export { CodePage as default } from '@/components/enpages/Legal/CodeConduct'
